import React, { useContext } from 'react'
import * as S from './styles'
import { TemplateCancellation } from '../../../components/template-cancellation'
import { TemplateCancellationContext } from '../../../components/template-cancellation/context'
import { TemplateContext } from '../../../components/template/context'
import { useTypePayment } from './hooks'
import PixKeyForm from '../../requests/components/pix-components/pix-key-form'
import { IconDoubt } from '../../../assets/svg/icon-doubt'

export const TypeOfPayment = () => {
  const { selectCrid } = useContext(TemplateContext)
  const { setCancellationData, cancellationData } = useContext(TemplateCancellationContext)

  const { onPixUpdated } = useTypePayment({ selectCrid, setCancellationData, cancellationData })

  return (
    <TemplateCancellation title="Solicitar cancelamento">
      <S.Container className="ph-no-capture">
        <S.Title>
          Reembolso utilizando PIX
          <a data-tip="Cadastre sua chave PIX para o reembolso. Quando necessário ou cabível, o estorno poderá ser realizado diretamente via PIX ou por estorno no cartão de crédito.">
            <IconDoubt color="black" size="15" />
          </a>
        </S.Title>
        <S.Tooltip effect="solid" place="bottom" />
        <PixKeyForm onPixUpdated={onPixUpdated} cancellationData={cancellationData} />
      </S.Container>
    </TemplateCancellation>
  )
}
